type ConsoleMethod = (...args: unknown[]) => void;

let originalError: ConsoleMethod | undefined;
let originalWarn: ConsoleMethod | undefined;
let originalInfo: ConsoleMethod | undefined;
let originalLog: ConsoleMethod | undefined;
let originalDebug: ConsoleMethod | undefined;

if (typeof console !== 'undefined') {
  originalError = console.error.bind(console) as ConsoleMethod;
  originalWarn = console.warn.bind(console) as ConsoleMethod;
  originalInfo = console.info.bind(console) as ConsoleMethod;
  originalLog = console.log.bind(console) as ConsoleMethod;
  originalDebug = (console.debug ?? console.log).bind(console) as ConsoleMethod;
}

export const originalConsole = {
  error: (...args: unknown[]): void => originalError?.(...args),
  warn: (...args: unknown[]): void => originalWarn?.(...args),
  info: (...args: unknown[]): void => originalInfo?.(...args),
  log: (...args: unknown[]): void => originalLog?.(...args),
  debug: (...args: unknown[]): void => originalDebug?.(...args),
};

export function diagnostic(enabled: boolean, ...args: unknown[]): void {
  if (!enabled) return;
  originalConsole.debug('[evam-logger]', ...args);
}
